export function initPledgeProgressBar() {
  const progressBar = document.querySelector(".progress-bar")

  function handleProgressBarIntersection(entries, observer) {
    entries.forEach((entry) => {
      if (entry.intersectionRatio > 0) {
        const progressElement = entry.target.querySelector(".progress")
        progressElement.classList.add("animate")
        progressElement.style.width = `${entry.target.dataset.percentage}%`
        observer.unobserve(entry.target)
      }
    })
  }

  if (progressBar) {
    const observer = new IntersectionObserver(handleProgressBarIntersection)
    observer.observe(progressBar)
  }
}
